<template>
    <section class="mt-16">
      <v-breadcrumbs
        :items="crumbs"
        divider="/"
        :class="$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        light
      />
      <h1 class="primary--text">
        <rp-icon icon="rp-money-blue-filled" class="mr-2" />
        {{ $t('expenses.edit_expense') }}
      </h1>
      <Expense :method="'update'" :expense="expense" />
    </section>
  </template>
  
  <script>
  import Expense from '@/components/expenses/Expense.vue'
  
  export default {
    components: { Expense },
    data() {
      return {
        expense: null
      }
    },
    mounted() {

      
    },
    computed: {
      crumbs() {
        return [
        { 
            text: this.$t('menu.dashboard'), 
            to: '/admin', 
            exact: true 
          },
          { 
            text: this.$t('menu.expenses_management'), 
            disabled: false, 
            to: '/' + this.$session.get('domain') + '/admin/expenses',
            exact: true,
          },
          { 
            text: this.$t('expenses.edit_expense'), 
            disabled: true 
          }
        ];
      }
    }
  }
  </script>
  